import { IHiddenRanges } from 'src/interfaces/global';
import Flex from 'src/styles/layouts/Flex';
import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { addHiddenRangesStyles, addTransition, mq } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledNavbar = styled.nav<{ isOpen?: boolean; isNavigationDisabled?: boolean }>`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;

	z-index: 502;

	height: 70px;

	user-select: none;

	${addTransition()}

	background-color: transparent;

	${(p) => css`
		${mq(
			EMediaQuery.md,
			`
				height: unset;
				min-height: 52px;
				max-height: 52px;

				${addTransition()}
				${!p.isNavigationDisabled ? `background-color: ${p.theme.colors.black + '30'};` : ''}

				z-index: 502;

				${
					p.isOpen
						? `
								min-height: 100vh;
								background-color: ${p.theme.colors.black};

								&::before {
									opacity: 1;
								}
						  `
						: ''
				}
			`
		)}
	`}

	${mq(EMediaQuery.sm, `padding: 0 8px;`)}
`;

export const StyledImgContainer = styled.div`
	display: flex;
	justify-content: center;

	width: 100%;

	& > img {
		position: absolute;
		bottom: 0;

		width: 2028px;
		height: 70px;

		pointer-events: none;
	}

	&:nth-child(2) {
		& > img {
			width: 1900px;
			height: 160px;
			bottom: -40px;
		}
	}
`;

export const StyledNavLinksList = styled.ul<IHiddenRanges & { isHidden?: boolean }>(
	(p) => `
	position: relative;

	display: flex;
	align-items: center;
	justify-content: flex-end;

	position: relative;

	${addHiddenRangesStyles(p)}

	${addTransition()}
	${p.isHidden ? 'opacity: 0; pointer-events: none;' : 'opacity: 1;'}

	${mq(
		EMediaQuery.md,
		`
		flex-direction: column;
		margin: 0 auto;
		width: calc(100% - 100px);
	`
	)}
`
);

export const StyledBurgerMenu = styled.button<{ isActive: boolean; isHidden?: boolean }>(
	(p) => `
	position: relative;

	display: flex;
	justify-content: center;
	align-items: center;

	background-color: transparent;
	border: none;

	height: 34px;
	width: 34px;
	z-index: 200;

	cursor: pointer;

	${addTransition()}
	${p.isHidden ? 'opacity: 0; pointer-events: none;' : 'opacity: 1;'}

	& > span {
		position: absolute;
		height: 2px;
		width: 100%;

		user-select: none;

		border-radius: 1px;

		background-color: #474747;

		${addTransition()}

		&:nth-child(1) {
			margin-bottom: 50%;
		}

		&:nth-child(3) {
			margin-top: 50%;
		}

		${
			p.isActive
				? css`
						&:nth-child(1) {
							margin-bottom: 0;
							transform: rotate(45deg);
						}

						&:nth-child(2) {
							transform: rotate(-45deg);
						}

						&:nth-child(3) {
							margin-top: 0;
							opacity: 0;
							transform: rotate(45deg);
						}
				  `
				: ''
		}
	}
`
);

export const FlexMobileButtonEx = styled(Flex)<{ isClosed?: boolean }>`
	${(p) => css`
		${p.isClosed ? 'pointer-events: none;' : ''}
	`}
`;
